
import React, { useEffect } from "react";
import { Hero } from "@/components/AboutPage/Hero";
import { OurNameSection } from "@/components/AboutPage/OurNameSection";
import { WhatIsSelahSection } from "@/components/AboutPage/WhatIsSelahSection";
import { WhyWeBuiltSection } from "@/components/AboutPage/WhyWeBuiltSection";
import { GodsWordSection } from "@/components/AboutPage/GodsWordSection";
import { WhoItsForSection } from "@/components/AboutPage/WhoItsForSection";
import { JoinMissionSection } from "@/components/AboutPage/JoinMissionSection";
import { useMetadata } from "@/hooks/useMetadata";
import PreloadResources from "@/components/PreloadResources";

const About = () => {
  // Set the metadata for the page
  useMetadata({
    title: "About Selah | Bible Tools & AI for Faith",
    description: "Learn about Selah's mission to provide AI-powered tools grounded in Scripture to deepen your understanding of God's Word and strengthen your faith journey.",
  });

  // Preload images for the About page
  const aboutPageImages = [
    "https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//tranparent%20logo.png",
    "https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//about1.png",
    "https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//about%202.png",
    "https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//about%203.png",
    "https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//about%204.png"
  ];
  
  return (
    <div className="bg-heaven-white min-h-screen">
      <PreloadResources resources={aboutPageImages} />
      <Hero />
      <OurNameSection />
      <WhatIsSelahSection />
      <WhyWeBuiltSection />
      <GodsWordSection />
      <WhoItsForSection />
      <JoinMissionSection />
    </div>
  );
};

export default About;
